import { server } from '../config';
import { getECSFlag } from '../lib/common';

export const GetFaqSearch = async (paramsData) => {
  try {
    const url = `${server.apiURL}csportal/searchFaqQuestion`;
    const options = {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        credentials: 'include',
      },
      body: JSON.stringify(paramsData),
    };
    const result = await fetch(url, options);
    return result.json();
  } catch (err) {
    console.log(err);
    return {};
  }
};

export const getContractType = async (parentId, city) => {
  try {
    const url = `${server.apiURL}csportal/getContractType?parentId=${parentId}&city=${city}`;
    const result = await fetch(url, {
      credentials: 'include',
    });
    return result.json();
  } catch (error) {
    return { result: '' };
  }
};

export const CreateTicket = async (paramsData) => {
  const url = `${server.apiURL}csportal/ticket`;
  const options = {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      credentials: 'include',
    },
    body: JSON.stringify(paramsData),
  };

  const fetchResponse = await fetch(url, options);
  const response = await fetchResponse.json();
  const responseData = response;
  return responseData;
};

export const getEditMyBusinessInfo = async (paramsData, projectId) => {
  try {
    const url = `${server.apiURL}${projectId}/editMyBusinessInfo`;
    const options = {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        credentials: 'include',
      },
      body: JSON.stringify(paramsData),
    };
    const result = await fetch(url, options);
    const response = await result.json();
    if (!response || (response.errorCode && response.errorCode === 1)) {
      return null;
    }
    return response?.result;
  } catch (err) {
    console.log(err);
    return {};
  }
};

export const GetDispoDetials = async (params, domainFlag = 0, projectId = '') => {
  const ecsFlag = getECSFlag();
  try {
    const category = params.category || '';
    const vertical = params.vertical || '';
    const ticketCreator = params.ticketCreator || '';
    const issueFlg = params.issue_flg || '';
    const url = `${
      domainFlag === 1
        ? `${server.apiURL}${projectId}/getTicketIssueAndSubIssue`
        : `${server.apiURL}wrapper/ticket/issues`
    }?category=${category}&vertical=${vertical}&ticket_creator=${ticketCreator}&issue_flg=${issueFlg}&csportal_flg=${
      issueFlg !== 'all' && domainFlag === 1 ? 1 : 0
    }&isIssueGenioFlag=${projectId === 'genio' ? 1 : 0}&ecsFlag=${ecsFlag}`;

    const response = await fetch(url, { credentials: 'include' });
    const data = response ? await response.json() : [];
    if (data.errorCode === 0 && data.result && data.result.data.length) {
      return data.result.data;
    }
    return [];
  } catch (err) {
    console.log(err);
    return [];
  }
};

export const uploadFiles = async (fileList) => {
  const formdata = new FormData();
  fileList.forEach((file) => {
    formdata.append(`file`, file, file.name);
  });
  try {
    const url = `${server.apiURL}tickets/uploadFile`;
    const requestOptions = {
      method: 'POST',
      headers: {},
      body: formdata,
      credentials: 'include',
    };
    const response = await fetch(url, requestOptions);
    const data = await response.json();
    if (data && data.errorCode === 0 && data.result) {
      return data.result;
    }
    return data.result;
  } catch (e) {
    console.log('Error saving data', e);
    throw new Error(e.message || 'Image not uploaded');
  }
};

export const getContractInfo = async (paramsData) => {
  try {
    const url = `${server.apiURL}contract/contractInfo`;
    const options = {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        credentials: 'include',
      },
      body: JSON.stringify(paramsData),
    };
    const result = await fetch(url, options);
    const response = await result.json();
    if (!response || (response.errorCode && response.errorCode === 1)) {
      return null;
    }
    return response.result;
  } catch (err) {
    console.log(err);
    return {};
  }
};

export const sendToGenioPDG = async (paramsData) => {
  try {
    const url = `${server.apiURL}contract/sendtogeniopdg`;
    const options = {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        credentials: 'include',
      },
      body: JSON.stringify(paramsData),
    };
    const result = await fetch(url, options);
    const response = await result.json();
    if (!response || (response.errorCode && response.errorCode === 1)) {
      return null;
    }
    return response.result;
  } catch (err) {
    console.log(err);
    return {};
  }
};

export const getPaymentsInfo = async (paramsData) => {
  try {
    const url = `${server.apiURL}payments/getPaymentsInfo`;
    const options = {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        credentials: 'include',
      },
      body: JSON.stringify(paramsData),
    };
    const result = await fetch(url, options);
    const response = await result.json();
    if (!response || (response.errorCode && response.errorCode === 1)) {
      return null;
    }
    return response.result;
  } catch (err) {
    console.log(err);
    return {};
  }
};

export const getRegisterFcm = async (paramsData) => {
  const url = `${server.apiURL}leads/getRegisterFcm`;
  const options = {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      credentials: 'include',
    },
    body: JSON.stringify(paramsData),
  };
  const result = await fetch(url, options);
  return result.json();
};

export const getStatistics = async (paramsData) => {
  const body = { ...paramsData, backUrl: encodeURI(window.location.href) };
  const url = `${server.apiURL}leads/autoDiagnose`;
  const options = {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      credentials: 'include',
    },
    credentials: 'include',
    body: JSON.stringify(body),
  };
  const result = await fetch(url, options);
  return result.json();
};

export const getCompanyDetails = async (docId) => {
  try {
    if (!docId) {
      throw new Error('Invalid Params!');
    }
    const result = await fetch(`${server.apiURL}leads/getCompanyDetails?docId=${docId}`, {
      credentials: 'include',
    });
    return result.json();
  } catch (e) {
    console.log('Error in getCompanyDetails data');
    throw new Error(e.message || 'Error in getCompanyDetails');
  }
};

export const GetFaqs = async (paramsData) => {
  const url = `${server.apiURL}csportal/getFaqs?key=${paramsData.key}&backUrl=${encodeURI(window.location.href)}`;
  const options = {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      credentials: 'include',
    },
    body: JSON.stringify(paramsData),
  };
  const result = await fetch(url, options);
  return result.json();
};

export const bannerTickerCreate = async (paramsData) => {
  try {
    const url = `${server.apiURL}csportal/bannerTicketCreate`;
    const options = {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        credentials: 'include',
      },
      body: JSON.stringify(paramsData),
    };
    const fetchResponse = await fetch(url, options);
    const response = await fetchResponse.json();
    const responseData = response;
    return responseData;
  } catch (e) {
    console.log('error in bannerTickerCreate', e);
    return null;
  }
};

export const GetBannerFaqs = async (paramsData) => {
  const url = `${server.apiURL}csportal/banner?key=${paramsData.key}&backUrl=${encodeURI(window.location.href)}`;
  const options = {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      credentials: 'include',
    },
    body: JSON.stringify(paramsData),
  };
  const result = await fetch(url, options);
  return result.json();
};

export const bannerUpdateHLink = async (paramsData) => {
  const { docid, hlink } = paramsData;
  const result = await fetch(`${server.apiURL}csportal/bannerUpdateHLink?docid=${docid}&hlink=${hlink}`, {
    credentials: 'include',
  });
  const response = await result.json();
  return response;
};

export const getBusinessData = async (params, domainFlag = 0) => {
  try {
    const url = `${domainFlag === 1 ? `${server.apiURL}genio` : `${server.apiURL}listing`}/getBusiness?city=${
      params.city
    }&companyName=${params.companyName}&parentId=${params.parentId}&phone=${params.phone}&emailId=${
      params.emailId
    }&pincode=${params.pincode}&page=${params.page}`;

    const res = await fetch(url, { credentials: 'include' });
    const data = await res.json();
    if (data.errorCode !== 0) {
      throw new Error(data.message || 'Error fetching bookings data');
    }
    return data.result;
  } catch (e) {
    console.log('Error fetching getBusiness data');
    throw new Error(e.message || 'Error fetching business data');
  }
};

export const getDecsCities = async (domainFlag = 0) => {
  try {
    const url = `${domainFlag === 1 ? `${server.apiURL}genio` : `${server.apiURL}listing`}/getCities`;
    const res = await fetch(url, { credentials: 'include' });
    const data = await res.json();
    if (data.errorCode !== 0) {
      throw new Error(data.message || 'Error fetching cities');
    }
    return data.result || {};
  } catch (e) {
    console.log('Error fetching getDecsCities data');
    throw new Error(e.message || 'Error fetching cities');
  }
};

export const sendTicketsApi = async ({ description, error }) => {
  try {
    const url = `${server.apiURL}tickets/sendTicketsApi?description=${description}&error=${error}`;
    const requestOptions = {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
      credentials: 'include',
    };

    const response = await fetch(url, requestOptions);
    const data = await response.json();
    if (data.errorCode !== 0) {
      throw new Error(data.message || 'Error fetching sendTicketsApi');
    }
    return data;
  } catch (e) {
    throw new Error(e.message || 'Error fetching sendTicketsApi Data');
  }
};

export const createTicketFeedback = async (paramsData) => {
  const url = `${server.apiURL}csportal/createTicketFeedback`;

  const options = {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      credentials: 'include',
    },
    body: JSON.stringify(paramsData),
  };
  const result = await fetch(url, options);
  return result.json();
};

export const getTicketIssueTypes = async (paramsData) => {
  const url = `${server.apiURL}csportal/getTicketIssueTypes`;

  const options = {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      credentials: 'include',
    },
    body: JSON.stringify(paramsData),
  };
  const result = await fetch(url, options);
  return result.json();
};

export const saveTicketData = async (params) => {
  try {
    const url = `${server.apiURL}csportal/updateTicket`;
    const requestOptions = {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(params),
      credentials: 'include',
    };
    const response = await fetch(url, requestOptions);
    const data = await response.json();
    const { result } = data;
    return result || {};
  } catch (e) {
    console.log('Error saveTicketData', e);
    throw new Error(e.message || 'Error saveTicketData');
  }
};

export const sendCommunication = async (paramsBody) => {
  try {
    const url = `${server.apiURL}csportal/sendCommunication`;
    const requestOptions = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(paramsBody),
      credentials: 'include',
    };
    const response = await fetch(url, requestOptions);
    const data = await response.json();
    return data;
  } catch (e) {
    console.log(e.message);
    throw new Error(e.message || 'Error sendCommunication');
  }
};

export const getClickTrackersInfo = async (paramsData) => {
  try {
    const url = `${server.apiURL}csportal/addClickTrackers`;
    const options = {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        credentials: 'include',
      },
      body: JSON.stringify(paramsData),
    };
    const result = await fetch(url, options);
    const response = await result.json();
    return response;
  } catch (error) {
    console.error('Err in getClickTrackersInfo:', error);
    return {};
  }
};

export const getAddOnCampaigns = async (paramsData) => {
  try {
    const url = `${server.apiURL}csportal/getAddOnCampaigns`;
    const options = {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        credentials: 'include',
      },
      body: JSON.stringify(paramsData),
    };
    const response = await fetch(url, options);
    const data = await response.json();
    return data;
  } catch (err) {
    console.log('Error in getAddOnCampaigns: ', err);
    return {};
  }
};

export const checkNoLeads = async (parentId, city, docid) => {
  try {
    const url = `${server.apiURL}csportal/checkNoLeads?parentId=${parentId}&city=${city}&docid=${docid}`;
    const response = await fetch(url, { credentials: 'include' });
    const data = await response.json();
    if (data.errorCode === 0 && data.result) {
      return data.result;
    }
    return {};
  } catch (error) {
    console.log(error);
    return {};
  }
};
